import { type RequestServiceOptions, utils } from '@atlaskit/util-service-support';

type JiraNavigationRequestProps = {
	query: string;
};

type JiraNavigationResponseProps = {
	url: string;
};

export const getJiraNavigationURL = ({
	query,
}: JiraNavigationRequestProps): Promise<JiraNavigationResponseProps> => {
	const url = `/rest/navigation/4/quicksearch?searchString=${query}`;

	const options: RequestServiceOptions = {
		requestInit: {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
			referrerPolicy: 'strict-origin-when-cross-origin',
		},
	};

	const supplier = utils.requestService<any>({ url }, options);
	return supplier;
};
